import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { HeadTypeLoft } from '../../api/models';

export type TABLE_TYPE = Table<HeadTypeLoft>;

export const TABLE = 'headTypeLoft';
const SCHEMA = 'headTypeLoftId';

class HeadTypeLoftDatabase implements DataRepository<HeadTypeLoft> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<HeadTypeLoft | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: HeadTypeLoft, key: Key): Promise<HeadTypeLoft> {
    return this.db[TABLE].put(payload, key);
  }

  bulkAdd(payload: HeadTypeLoft[]): Promise<HeadTypeLoft[]> {
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<HeadTypeLoft[]> {
    return this.db[TABLE].toArray();
  }
}

export const HeadTypeLoftDB = new HeadTypeLoftDatabase(db);
